export default "__VITE_ASSET__C2$lhf7w__"